module.exports = __webpack_public_path__ + "static/img/zhuanxiang1.db786bd7.webp";